import { TABLES } from '@/utils/constants';
import { getRecord } from '@/utils/helpers/data';
import { DENTIST_COLUMNS, Dentist } from '@/utils/schema';
import { supabase } from '@/utils/supabase';

export type { Dentist };
export const COLUMNS = DENTIST_COLUMNS;

/**
 * Retrieves a single dentist by their ID.
 * @param dentistId - The ID of the dentist to retrieve.
 * @returns The requested dentist or null if not found.
 * @throws Will throw an error if the retrieval fails.
 */
export const getDentist = async (
  dentistId: string | null
): Promise<Dentist | null> => {
  if (!dentistId) return null;
  return getRecord<Dentist>(TABLES.DENTISTS, COLUMNS.ID, dentistId);
};

/**
 * Retrieves all dentists associated with a specific clinic ID.
 * @param clinicId - The ID of the clinic.
 * @returns An array of dentists.
 * @throws Will throw an error if the retrieval fails.
 */
export const getDentistsByClinicId = async (
  clinicId: string | null
): Promise<Dentist[]> => {
  if (!clinicId) return [];

  const { data, error } = await supabase.rpc('get_dentists_by_clinic_id', {
    p_clinic_id: clinicId
  });

  if (error) throw new Error(error.message);

  return data ?? [];
};
